import { Link } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import { BookOpen, Trophy, Users, TrendingUp } from 'lucide-react'

export function HomePage() {
  const { user } = useAuthStore()

  return (
    <div className="space-y-8">
      {/* Welcome Section */}
      <section className="card p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          안녕하세요, {user?.displayName || user?.fullName}님! 👋
        </h1>
        <p className="text-gray-600">
          오늘도 즐거운 학습 되세요.
        </p>
      </section>

      {/* Quick Actions */}
      <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <Link to="/learn" className="card p-6 hover:shadow-md transition-shadow group">
          <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
            <BookOpen className="w-6 h-6 text-primary-600" />
          </div>
          <h3 className="font-semibold text-gray-900 mb-1">학습 시작하기</h3>
          <p className="text-sm text-gray-500">오늘의 학습을 시작해보세요</p>
        </Link>

        <div className="card p-6">
          <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
            <Trophy className="w-6 h-6 text-green-600" />
          </div>
          <h3 className="font-semibold text-gray-900 mb-1">나의 성취</h3>
          <p className="text-sm text-gray-500">학습 기록을 확인하세요</p>
        </div>

        <div className="card p-6">
          <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
            <TrendingUp className="w-6 h-6 text-purple-600" />
          </div>
          <h3 className="font-semibold text-gray-900 mb-1">학습 통계</h3>
          <p className="text-sm text-gray-500">진도율을 확인하세요</p>
        </div>

        <div className="card p-6">
          <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
            <Users className="w-6 h-6 text-orange-600" />
          </div>
          <h3 className="font-semibold text-gray-900 mb-1">커뮤니티</h3>
          <p className="text-sm text-gray-500">다른 학습자들과 소통하세요</p>
        </div>
      </section>

      {/* Recent Activity */}
      <section className="card p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">최근 학습</h2>
        <div className="text-center py-8 text-gray-500">
          <p>아직 학습 기록이 없습니다.</p>
          <Link to="/learn" className="btn btn-primary btn-md mt-4">
            학습 시작하기
          </Link>
        </div>
      </section>
    </div>
  )
}


